import { expiringLicenseInitialData } from "./InitialData"

export type ExpiringLicenseTableType = {
  licenseTypeID: number
  name: string
  product: string
  productID: number
  membersAssigned: []
  expires: string
  total: number
}

const convertToExpiringLicenseReport = (data: expiringLicenseInitialData): ExpiringLicenseTableType[] => {

  const licenses = data?.licenses ?? []

  const licenseData = licenses.map(license => ({
    licenseTypeID: license.licenseTypeID ?? 0,
    name: license.name ?? '',
    product: license.product ?? '',
    productID: license.productID ?? 0,
    membersAssigned: license.membersAssigned ?? [],
    expires: license.expires ?? '',
    total: license.total ?? 0,
  }));

  return licenseData;
  
}

export const ExpiringLicenseTableData = (data: expiringLicenseInitialData): ExpiringLicenseTableType[] => {
  return convertToExpiringLicenseReport(data)
}
